import styled, {css} from "styled-components";

export const InputBox = styled.input<{disabled: boolean}>`
  appearance: none;
  position: relative;
  height: 1.8rem;
  width: 1.8rem;
  cursor: ${props => props.disabled ? "auto" : "pointer"};
  
  display: inline-flex;
  align-items: center;
  justify-content: center;

  background-color: ${props => props.theme.colors.background};
  border: 1px solid ${props => props.theme.colors.boxBorderContrast};
  border-radius: 0.5rem;
  
  &:checked {
    background-color: ${props => props.theme.colors.brandPrimary};
    
    &:after {
      content: '\\2713';
      display: block;
      height: 100%;
      font-size: 13px;
      line-height: 1.8rem;
      color:  ${props => props.theme.colors.background};
      font-weight: bold;      
    }
    
    & ~ .filter-title {
       color: ${props => props.theme.colors.brandPrimary};        
    }
  }
  
  ${props => props.type === 'radio' && css` border-radius: 10px; ` }  
`;